import {createApp} from 'vue';
import CuratedProducts from "../../../components/stores/CuratedProducts.vue";

export function main(payload) {
    const app = createApp(CuratedProducts, { clearanceCornerLink: payload.clearanceCornerLink });
    app.mount('#vue-container');
}
